import { documents } from './Documents'
import { partners } from './Partner'
import { reassign } from './Reassign'
import { statistics } from './Statistics'
import { user } from './User'

export const resources = [user, statistics, partners, reassign, ...documents]
